/**
 * Created by Kamil on 24.05.2017.
 */
import React, {Component} from 'react';
import './MoreSection.css';

class MoreSection extends Component {
    render() {
        if(true) {
            return (
                <div className="MoreSection">
                    <a className="MoreSection-datasheet" href={this.props.datasheetURL}>Pobierz dokumentację</a>
                    <a href={this.props.link} className="MoreSection-link btn btn-outline-primary btn-sm">Zobacz</a>
                </div>
            );
        } else {
            return (
                <div className="MoreSection">
                    <a href={this.props.link} className="MoreSection-link btn btn-outline-primary btn-sm">Zobacz</a>
                </div>
            );
        }
    }
}

export default MoreSection;


// WEBPACK FOOTER //
// ./src/components/MoreSection.js